import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_339: DocMigration = {
  maxSchemaVersion: "0.0.339",
  description: "Migrate Note textBoxWidth and textBoxHeight from SheetPoints to SheetInches",
  apply(json: any) {
    const TEXTBOX_SCALE_FACTOR = 1 / 72;

    for (const annoId in json.annotation) {
      const anno = json.annotation[annoId];
      if (anno.type === "NOTE") {
        if (typeof anno.textBoxWidth === "number") {
          anno.textBoxWidth *= TEXTBOX_SCALE_FACTOR;
        }
        if (typeof anno.textBoxHeight === "number") {
          anno.textBoxHeight *= TEXTBOX_SCALE_FACTOR;
        }
      }
    }
    return json;
  },
};

export default migration_0_0_339;
